import React, { useMemo } from 'react';
import * as yup from 'yup';
import { SchemaOf } from 'yup';
import { DSection, RhFormWrapper, RhSingleAutocomplete } from '../../../../../dum';
import {
    useOrderRequestOrderRequestStatusInputQuery,
    useUpdateOrderRequestStatusMutation,
} from '../../../../../../services';
import {
    FIELD_LABELS,
    shortLabel,
    transformToNumber,
} from '../../../../../../helpers';

interface IOrderRequestStatusChange {
    order_request_status_id?: number | null;
}

interface IOrderRequestStatusChangeFormProps {
    orderRequestId: number;
    currentStatusId?: number | null;
    onSuccess: () => void;
}

// Status-only form, separate from the request upsert. The upsert no longer
// accepts a status, so this admin-only mutation is the only way to move a
// request between statuses.
export function OrderRequestStatusChangeForm({
    orderRequestId,
    currentStatusId,
    onSuccess,
}: IOrderRequestStatusChangeFormProps) {
    const { data } = useOrderRequestOrderRequestStatusInputQuery();
    const [mutation, { loading }] = useUpdateOrderRequestStatusMutation();

    const orderRequestStatuses = data?.getOrderRequestStatuses || [];

    const initialValues = useMemo<IOrderRequestStatusChange>(() => {
        return {
            order_request_status_id: currentStatusId || 1,
        };
    }, [currentStatusId]);

    const validationSchema: SchemaOf<IOrderRequestStatusChange> = yup.object({
        order_request_status_id: yup
            .number()
            .transform(transformToNumber)
            .nullable()
            .required(`'Status' es obligatorio`),
    });

    return (
        <RhFormWrapper
            validationSchema={validationSchema}
            initialValues={initialValues}
            disabled={loading}
            onSubmit={async (formData) => {
                try {
                    await mutation({
                        variables: {
                            OrderRequestId: orderRequestId,
                            OrderRequestStatusId:
                                formData.order_request_status_id!,
                        },
                    });
                    onSuccess();
                } catch (e) {
                    console.error(e);
                }
            }}
        >
            <DSection alwaysOpen>
                <RhSingleAutocomplete
                    itemText={'name'}
                    itemValue={'id'}
                    name={'order_request_status_id'}
                    label={shortLabel(FIELD_LABELS.order_request_status_id)}
                    options={orderRequestStatuses}
                />
            </DSection>
        </RhFormWrapper>
    );
}
